import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@material-ui/core";
import { useDialog } from "hooks/ui";
import { useForm } from "hooks/forms";

export default function useEditDialog(onConfirm) {
  const { isOpen, open, close } = useDialog();
  const [zone, setZone] = useState({ id: "", name: "" });
  const { values, handleUserInput, reset } = useForm({ name: zone.name });

  //update state from props
  useEffect(() => {
    reset({ name: zone.name });
  }, [zone, reset]);

  const onClose = (confirmed) => {
    if (confirmed && values.name) {
      onConfirm(zone, values.name);
      reset({ name: "" });
    }
    close();
  };

  const openWithZone = (zone) => {
    setZone(zone);
    open();
  };

  const display = (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth="sm"
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Modifier la zone {zone.name}
      </DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          id="name"
          name="name"
          label="Nouveau nom de la zone"
          required
          value={values.name}
          onChange={handleUserInput}
          autoFocus={isOpen}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="primary">
          Annuler
        </Button>
        <Button onClick={() => onClose(true)} color="primary">
          Modifier
        </Button>
      </DialogActions>
    </Dialog>
  );
  return { open: openWithZone, display };
}
